export type CatalogItem = {
    id: string;
    title: string;
    description: string;
    category: number;
    teamId: string;
    team?: any;
    version: string;
    status: number;
    createby_id?: string | null;
    createby_id_name?: string | null;
    createdby?: string | null;
    createdby_name?: string | null;
    modifiedby?: string | null;
    modifiedby_name?: string | null;
    ts_created: string;
    ts_modified?: string | null;
    file?: string | null;
    originalFileName?: string | null;
    versions?: CatalogItem[];
};

export const CATALOG_CATEGORY_MAP: Record<number, string> = {
    0: 'SOP',
    1: 'Training',
    2: 'Policy',
    3: 'Work Instruction',
    4: 'OCALC',
    5: 'Template PPT',
};

export const CATALOG_STATUS_MAP: Record<number, string> = {
    0: 'Draft',
    1: 'Published',
    2: 'Archived',
};

export type CatalogListData = {
    data: CatalogItem[];
    total: number;
    header?: any;
};

export type GetCatalogListRequest = {
    skip?: number;
    take?: number;
    filter?: string;
    category?: number;
    status?: number;
};

export type CreateCatalogRequest = {
    title: string;
    description: string;
    category: number;
    teamId: string;
    version: string;
    file: string;
    originalFileName?: string | null;
    status: number;
};

export type UpdateCatalogRequest = {
    id: string;
    title: string;
    originalFileName?: string | null;
    description: string;
    category: number;
    teamId: string;
    version: string;
    file: string;
    status: number;
};

export type UploadCatalogForm = {
    file: File | string;
    document_title: string;
    category: string | number;
    group_id: string;
    description: string;
};

export type CatalogFilter = {
    search?: string;
    category?: string;
    status?: string;
    uploaded_by?: string;
};
